module.exports = __webpack_public_path__ + "img/qrcode.0e278b59.png";